import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

// This component renders precisely when the app is in a broken state — including
// the top-level ErrorBoundary, whose fallback may render before/outside our custom
// ThemeProvider. So it must NOT depend on theme.designTokens (absent on MUI's
// default theme). slate[900] is inlined here as a hard literal on purpose.
const SLATE_900 = '#0F172A';

export const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: theme.spacing(2.5),
  height: 500,
  color: SLATE_900,
  padding: theme.spacing(0, 5),
}));

export const ErrorImage = styled(Box)({
  maskImage: 'url("/assets/images/error.png")',
  maskSize: 'contain',
  maskRepeat: 'no-repeat',
  maskPosition: 'center',
  width: 240,
  height: 240,
  backgroundColor: SLATE_900,
});

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(42),
  width: 'fit-content',
  maxWidth: 600,
})).withComponent('h1');

export const TextContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: theme.spacing(3.75),
}));
